import React, { useState } from 'react';
import { acadamicDropdown } from "../Components/DropdownNavItems"
import { Link } from 'react-router-dom';
import "../index.css"

const AcadamicDropdown = () => {
    const [dropDown, setDropDown] = useState(false)
    return (
        <div>
            <>
                <ul className={dropDown ? "acadamic-submenu clicked": "acadamic-submenu"} onClick={() => setDropDown(!dropDown)}>
                    {
                        acadamicDropdown.map(item => {
                            return (
                                <li key={item.id}>
                                    <Link to={item.path} className={item.cName} onClick={() => setDropDown(false)}>{item.title}</Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </>
        </div>
    );
}

export default AcadamicDropdown
